import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import {logo} from '../../assets/img/dashCategoris'
import { arrowLeft, check, notCheck, point } from '../../assets/svg/dashboard/main'
import { useHistory, useLocation } from 'react-router-dom'
import cn from 'classnames'
import { Check, Input } from '../../assets/NewDashboard'
import { useDispatch, useSelector } from 'react-redux'
import { getCollegeData, getData } from '../../actions/dashboard'
import ReactLoader from 'react-loader'
import { DASHBOARD_ENTITIES } from '../../utils/const'
import { Radio } from '../../assets/NewDashboard'



const Accreditation = () => {

  
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const { main: data, loading } = useSelector(state => state.dashboard)

  // уровень образования держим в query, чтобы он не сбрасывался при возврате со страницы специальности
  const spoMode = new URLSearchParams(location.search).get('level') === 'spo'
  const setSpoMode = (value) => history.replace({ search: value ? '?level=spo' : '' })

  const [search, setSearch] = useState('')



  const ENTITIES = Object.values(spoMode ? DASHBOARD_ENTITIES.spo : DASHBOARD_ENTITIES.high)

  useEffect(() => {
    dispatch(spoMode ? getCollegeData(search) : getData(search))
  }, [spoMode, search])
  
  const goTo = (link) => (e) => {
    e.stopPropagation()
    history.push(link)
  } 




  const renderRow = (item, index) => {
    const { min, max, average } = item.statistic
    const complete = average >= (spoMode ? 35 : 90)
    return (
      <tr key={index}>
        <td>{item.name}</td>
        {Object.values(ENTITIES).map((entity, i) => {
          const value = item[entity.name]
          const notAllowed = value < 0
          const result = notAllowed ? 'не учитывается' : value
          const mode = value <= entity.min ? 'notComplete' : value >= entity.max ? 'complete' : 'middle'
          const path = `${entity.path}/${item.mpid}`
          return (
            <td onClick={goTo(path)}>
              <div>
                {!notAllowed && <Check mode={mode}/>}  
                {result}
              </div>
            </td>
          )
        })}
        <td>
          <p>{min}</p>
          <p style={{color: complete ? 'green' :'red'}}>{average}</p>
          <p>{max}</p>
        </td>
      </tr>
    )
  }


  return (
    <div className={styles.accreditationWrap}>
      <div onClick={goTo('/dashboard_new')}>
        <div>{arrowLeft}</div>
        <h2>Количество баллов аккредитационных показателей <br/> по реализуемым образовательным программам высшего образования</h2>
      </div>
      <div>
        <div>
          <div>
            <Radio disabled={loading} title='Высшее образование' checked={!spoMode} onChange={() => setSpoMode(false)}/>
          </div>
          <div>
            <Radio disabled={loading} title='Среднее профессиональное образование' checked={spoMode} onChange={() => setSpoMode(true)}/>
          </div>
        </div>
        <Input onChange={setSearch}/>
      </div>
      <ReactLoader loaded={!loading} color='#5b76e5'>
        <table>
          <thead>
            <tr>
              <th>Наименование образовательной программы</th>
              {Object.values(ENTITIES).map(({title}) => {
                const width = !['ЭИОС', 'ВСОКО'].includes(title) && '220px' 
                return (
                  <th style={{width}}>{title}</th>
                )
              })}
              <th>
                минимум<br/>результат<br/>максимум
              </th>
            </tr>
            {/* <tr>
              <th>Критериальное значение аккредитационного показателя</th>
              <th>от 65 = 10 <br/> от  60 до 65 = 5 <br/> менее 60 = 0</th>
              <th>имеется = 10 <br/> отсутствует = 0</th>
              <th>соотв. ФГОС = 20 <br/> не соотв. ФГОС = 0</th>
              <th>соотв. ФГОС = 20 <br/> не соотв. ФГОС = 0</th>
              <th>от 65 = 75 <br/> от  55 до 64 = 50 <br/> менее 55 = 0</th>
              <th>имеется = 10 <br/> отсутствует = 0</th>
            </tr> */}
          </thead>
          <tbody>
            {data?.map(renderRow)}
          </tbody>
        </table>
      </ReactLoader>
    </div>
  )
}


export default Accreditation